/**
 * Call Notification API Client (V1104: Polling Architecture)
 */

import apiClient from "./client";

export interface CallNotificationDto {
  id: number;
  organizationId: number;
  consultId: number | null;
  conversationId: number | null;
  callUuid: string;
  callerNumber: string | null;
  calledNumber: string | null;
  customerName: string | null;
  direction: string;
  status:
    | "INCOMING"
    | "IN_PROGRESS"
    | "ENDED"
    | "ANALYZING"
    | "ANALYZED"
    | "SKIPPED"
    | "FAILED";
  callStartedAt: string | null;
  callConnectedAt: string | null;
  callEndedAt: string | null;
  durationSeconds: number | null;
  analysisSummary: string | null;
  isRead: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface PageResponse<T> {
  content: T[];
  totalElements: number;
  totalPages: number;
  number: number;
  size: number;
}

export const callNotificationApi = {
  /**
   * 조직별 알림 목록 조회
   */
  getNotifications: async (
    organizationId: number,
    params?: { unreadOnly?: boolean; page?: number; size?: number },
  ): Promise<PageResponse<CallNotificationDto>> => {
    const { data } = await apiClient.get("/api/call-notifications", {
      params: {
        organizationId,
        unreadOnly: params?.unreadOnly ?? false,
        page: params?.page ?? 0,
        size: params?.size ?? 20,
      },
    });
    return data;
  },

  /**
   * 미읽음 개수 조회
   */
  getUnreadCount: async (
    organizationId: number,
  ): Promise<{ count: number }> => {
    const { data } = await apiClient.get(
      "/api/call-notifications/unread-count",
      {
        params: { organizationId },
      },
    );
    return data;
  },

  /**
   * 단건 읽음 처리
   * V1224+: 서버가 Authentication에서 userId 추출하므로 클라이언트 전달 불필요.
   *         notification의 organization_id와 JWT org 자동 검증(IDOR 방지).
   */
  markAsRead: async (id: number): Promise<CallNotificationDto> => {
    const { data } = await apiClient.put(
      `/api/call-notifications/${id}/read`,
    );
    return data;
  },

  /**
   * 전체 읽음 처리
   * V1224+: userId 파라미터 제거. 서버에서 JWT로 extract.
   */
  markAllAsRead: async (
    organizationId: number,
  ): Promise<{ updated: number }> => {
    const { data } = await apiClient.put(
      "/api/call-notifications/read-all",
      null,
      {
        params: { organizationId },
      },
    );
    return data;
  },
};
